import { render, staticRenderFns } from "./notification-popover.vue?vue&type=template&id=333a388c"
import script from "./notification-popover.vue?vue&type=script&lang=js"
export * from "./notification-popover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports